import React from "react";

import { useDispatch, useSelector } from "react-redux";

import { styled } from "@mui/material/styles";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";

import { HeaderProps } from "./Header.props";
import { DRAWER_WIDTH } from "../Layout";
import { TextFieldSelect } from "@src/components/TextFieldSelect/TexttFieldSelect";
import { GlobalLoader } from "./GlobalLoader";
import { languages } from "./generator";
import { setCurrentLanguage } from "@src/store/app_manager/actionCreators";
import { selectCurrentLanguage } from "@src/store/app_manager/selector";
import { LocationGroupSelect } from "./component/LocationGroupSelect";
import { LocationSelect } from "./component/LocationSelect";

interface AppBarProps extends MuiAppBarProps {
  open: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  width: `calc(100% - ${theme.spacing(7)})`,
  boxShadow: "none",
  backgroundColor: "#E8E8E9",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: DRAWER_WIDTH,
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const AppHeader: React.FC<HeaderProps> = (props) => {
  const { open } = props;

  const dispatch = useDispatch();

  const currentLanguage = useSelector(selectCurrentLanguage);

  const handleLanguageChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    dispatch(setCurrentLanguage(e.target.value));
  };

  const userRole = JSON.parse(localStorage.getItem("userRole") || "[]") || "";

  return (
    <AppBar position="fixed" open={open}>
      <Box
        display="flex"
        gap="30px"
        alignItems="center"
        p="0 40px"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center" flexDirection="row">
          {/* REST GROUP ID */}
          <LocationGroupSelect />

          {/* REST SELECTOR  */}
          {!userRole.includes("Callcenter") ? <LocationSelect /> : null}
        </Box>

        <Box p="0 40px">
          <TextFieldSelect
            select
            value={currentLanguage}
            sx={{ padding: "0 5px" }}
            onChange={handleLanguageChange}
          >
            {languages.length ? (
              languages?.map((language: string) => (
                <MenuItem key={language} value={language}>
                  {language.toUpperCase()}
                </MenuItem>
              ))
            ) : (
              <Typography textAlign="center">Пусто</Typography>
            )}
          </TextFieldSelect>
        </Box>
      </Box>

      <GlobalLoader />
    </AppBar>
  );
};
export const Header = React.memo(AppHeader);
